import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["pagination"];

  connect() {
    this.scroller = this.element.querySelector("#message_headers");
    this.onScroll = () => {
      if (this.scroller.scrollTop < 60) this.loadMore();
    };
    this.onComplete = () => {
      this.loading = false;
      if (this.pendingLink) {
        this.pendingLink.removeEventListener("ajax:complete", this.onComplete);
        this.pendingLink.removeEventListener("ajax:error", this.onComplete);
        this.pendingLink = null;
      }
    };
    this.scroller.addEventListener("scroll", this.onScroll);
  }

  disconnect() {
    this.scroller.removeEventListener("scroll", this.onScroll);
    this.onComplete();
  }

  loadMore() {
    const link = this.paginationTarget.querySelector("a");
    if (!link || this.loading) return;
    this.loading = true;
    this.pendingLink = link;
    link.addEventListener("ajax:complete", this.onComplete);
    link.addEventListener("ajax:error", this.onComplete);
    link.click();
  }
}
